export const card = {
  components: {
   
    MuiCard: {
      styleOverrides: {
        root: {
          maxWidth: 345,
          border: "4px solid #eeebec",
          borderRadius: "5px",
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          fontSize: "15px",
          fontWeight: "600",
          backgroundColor: "#eeebec",
          padding: "6px",
        },
        avatar:{
          img: {
            width: "24px", // Make sure the image fills the entire Avatar
            height: "24px", // Make sure the image fills the entire Avatar
          },
        },
        title: {
          fontSize: "15px",
          fontWeight: "600",
          // textAlign: "center",
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          fontSize: "15px",
          fontWeight: "400",
        },
      },
    },
    // Add more component overrides if needed
  },
};
